<script>
import WootSnackbar from './Snackbar.vue';

export default {
  components: {
    WootSnackbar,
  },
  props: {
    duration: {
      type: Number,
      default: 2500,
    },
  },

  data() {
    return {
      snackMessages: [],
    };
  },

  mounted() {
    this.$emitter.on('newToastMessage', this.onNewToastMessage);
  },
  beforeDestroy() {
    this.$emitter.off('newToastMessage', this.onNewToastMessage);
  },
  methods: {
    getDurationForMessage(message, durationOverride) {
      if (durationOverride) {
        return durationOverride;
      }

      const messageLength = String(message || '').trim().length;
      const estimatedDuration = 2200 + messageLength * 45;

      return Math.max(this.duration, Math.min(12000, estimatedDuration));
    },
    removeSnackMessage(key) {
      this.snackMessages = this.snackMessages.filter(
        snackMessage => snackMessage.key !== key
      );
    },
    onNewToastMessage({ message, action, duration }) {
      const key = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const displayDuration = this.getDurationForMessage(message, duration);

      this.snackMessages.push({
        key,
        message,
        action,
        duration: displayDuration,
      });

      window.setTimeout(() => {
        this.removeSnackMessage(key);
      }, displayDuration);
    },
  },
};
</script>

<template>
  <transition-group
    name="toast-fade"
    tag="div"
    class="fixed left-0 right-0 top-4 z-[10060] my-0 mx-auto max-w-[25rem] overflow-hidden text-center"
  >
    <WootSnackbar
      v-for="snackMessage in snackMessages"
      :key="snackMessage.key"
      :message="snackMessage.message"
      :action="snackMessage.action"
      :duration="snackMessage.duration"
    />
  </transition-group>
</template>
